import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { DropdownMenu, IconButton, Typography, useStateInRef } from 'seagull';
import { TrashLine, Edit2Liner18, MoreVertical, CopyLiner24 } from 'seagull/icons';
import styles from "./ServicePackages.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const tabPanelId = 'services-in-pkg';
export default function ServicePackagesTab(props) {
  const {
    bundle,
    isSelected,
    testid,
    bundlesCount,
    isReadonly,
    onClick,
    onRemove,
    onChangeName,
    onDuplicate: handleDuplicate
  } = props;
  const getProps = useStateInRef(props);
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState(bundle.name);
  const inputRef = useRef();
  useEffect(() => {
    if (isEditingName) {
      const cancelEditOnEscapeKey = e => {
        if (e.key === 'Escape') {
          setEditedName(getProps().bundle.name);
          setIsEditingName(false);
        }
      };
      window.addEventListener('keydown', cancelEditOnEscapeKey);
      return () => window.removeEventListener('keydown', cancelEditOnEscapeKey);
    }
  }, [isEditingName]);
  const applyEdit = () => {
    onChangeName(editedName.trim(), bundle.id);
    setIsEditingName(false);
  };
  const onRename = () => {
    onClick(bundle.id);
    setIsEditingName(true);
    setTimeout(() => inputRef.current.focus());
  };
  return /*#__PURE__*/_jsxs("button", {
    role: "tab",
    className: cn(styles.tab, {
      [styles.editing]: isEditingName
    }),
    "aria-selected": isSelected ? 'true' : 'false',
    "aria-controls": tabPanelId,
    "data-testid": testid,
    onClick: function (_onClick2) {
      function onClick() {
        return _onClick2.apply(this, arguments);
      }
      onClick.toString = function () {
        return _onClick2.toString();
      };
      return onClick;
    }(() => onClick(bundle.id)),
    onDoubleClick: onRename,
    children: [isEditingName ? /*#__PURE__*/_jsx("form", {
      onSubmit: e => {
        e.preventDefault();
        applyEdit();
      },
      className: styles.form,
      children: /*#__PURE__*/_jsx(Typography, {
        as: "input",
        ref: inputRef,
        className: styles.nameInput,
        "data-testid": "".concat(testid, "-input"),
        value: editedName,
        onChange: e => setEditedName(e.target.value),
        onBlur: () => applyEdit()
      })
    }) : /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      children: bundle.name
    }), !isEditingName && !isReadonly && /*#__PURE__*/_jsxs(DropdownMenu, {
      onClose: (anchorEl, reason, event) => event.stopPropagation(),
      target: /*#__PURE__*/_jsx(IconButton, {
        noPadding: true,
        skin: "transparent",
        size: "small",
        "data-testid": "".concat(testid, "-dropdown"),
        onClick: e => e.stopPropagation(),
        children: /*#__PURE__*/_jsx(MoreVertical, {})
      }),
      children: [/*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx("div", {
          className: styles.iconContainer,
          children: /*#__PURE__*/_jsx(Edit2Liner18, {})
        }),
        "data-testid": "".concat(testid, "-edit"),
        onClick: e => {
          e.stopPropagation();
          onRename();
        },
        children: "Rename"
      }), bundlesCount < 3 && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(CopyLiner24, {}),
        "data-testid": "".concat(testid, "-duplicate"),
        onClick: e => {
          e.stopPropagation();
          handleDuplicate(bundle);
        },
        children: "Duplicate"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        skin: "error",
        "data-testid": "".concat(testid, "-remove"),
        iconStart: /*#__PURE__*/_jsx("div", {
          className: styles.iconContainer,
          children: /*#__PURE__*/_jsx(TrashLine, {})
        }),
        onClick: function (_onClick) {
          function onClick(_x) {
            return _onClick.apply(this, arguments);
          }
          onClick.toString = function () {
            return _onClick.toString();
          };
          return onClick;
        }(e => {
          e.stopPropagation();
          onClick(bundle.id);
          onRemove(bundle.id);
        }),
        children: "Remove"
      })]
    })]
  }, bundle.id);
}